import { State } from "../reducers/root";
import { Doctor } from "../types";

export const doctorsSelector: (state: State) => Doctor[] = (state) => {
  const offices = state.offices.data;
  const doctors = offices.map((i) => i.doctor);
  const filteredDoctors = doctors.filter((doctor, index, self) => {
    return self.findIndex((i) => i.id === doctor.id) === index;
  });
  return filteredDoctors;
};
